import { ClientHelper } from '../client/CreateNswagClient';

const extractReplayItems = (payload: any): any[] => {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.items)) return payload.items;
  if (Array.isArray(payload.messages)) return payload.messages;
  if (Array.isArray(payload.data)) return payload.data;
  return [payload];
};

export const createReplayRequester = (params: {
  getUserToken: () => string | undefined | Promise<string | undefined>;
  replayInFlightRef: React.MutableRefObject<Map<string, { inFlight: boolean; lastSeq: number; pending: number | null }>>;
  handleIncomingRef: React.MutableRefObject<(chatKey: string, payload: any, eventName?: string) => void>;
}) => {
  const { getUserToken, replayInFlightRef, handleIncomingRef } = params;

  const requestReplay = async (targetChatId: string, lastSeq: number) => {
    const existing = replayInFlightRef.current.get(targetChatId);
    if (existing?.inFlight) {
      const nextPending = existing.pending === null ? lastSeq : Math.max(existing.pending, lastSeq);
      replayInFlightRef.current.set(targetChatId, { ...existing, pending: nextPending });
      return;
    }

    replayInFlightRef.current.set(targetChatId, { inFlight: true, lastSeq, pending: null });
    try {
      const token = await getUserToken();
      const signalRClient = ClientHelper.createSignalRClient(token as string);
      const replayPayload = await signalRClient.replay(targetChatId, lastSeq);
      const items = extractReplayItems(replayPayload);
      items.forEach(item => handleIncomingRef.current(targetChatId, item, 'replay'));
    } catch (err) {
      console.warn('SignalR replay failed', err);
    } finally {
      const latest = replayInFlightRef.current.get(targetChatId);
      if (!latest) return;
      if (latest.pending !== null && latest.pending > latest.lastSeq) {
        const pendingSeq = latest.pending;
        replayInFlightRef.current.set(targetChatId, { inFlight: false, lastSeq: pendingSeq, pending: null });
        requestReplay(targetChatId, pendingSeq);
        return;
      }
      replayInFlightRef.current.delete(targetChatId);
    }
  };

  return requestReplay;
};
